import Vue from "vue";
import VueRouter from "vue-router";
import Default from "@/views/Default";
import Comprovantes from "@/views/Comprovantes";
import InformesRendimentos from "@/views/InformesRendimentos";
import DadosCadastrais from "@/views/DadosCadastrais";
import Dependentes from "@/views/Dependentes";
import Home from "@/views/Home";
import Erro404 from "@/views/Erro404";
import Avisos from "@/views/Avisos";
import Telefonia from "@/views/Telefonia";
import Compras from "@/views/ComprasVarejo";
import Pip from "@/views/Pip";
import EspelhoPonto from "@/views/EspelhoPonto";
import Beneficios from "@/views/Beneficios";
import FaleComRh from "../views/FaleComRh.vue";
import MarcacoesPonto from "../views/MarcacoesPonto.vue";
import ItensDoVarejo from "../views/ItensDoVarejo.vue";
import Cartilha from "../views/Cartilha.vue";
import Programacao from "../views/Programacao.vue";
import Documentos from "../views/Documentos.vue";
import Avaliacao from "../views/Avaliacao.vue";
import InclusaoPonto from "../views/InclusaoPonto.vue";
import Oportunidades from "../views/Oportunidades.vue";
import Reservas from "../views/Reservas.vue";
import Vale from "../views/ValeRefeicao.vue";
import InclusaoPontoTeletex from "../views/InclusaoPontoTeletex.vue";
import Denuncia from "../views/Denuncia.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Default",
    component: Default,
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/comprovantes",
    name: "Comprovantes",
    component: Comprovantes,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/informesrendimentos",
    name: "InformesRendimentos",
    component: InformesRendimentos,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/dadoscadastrais",
    name: "DadosCadastrais",
    component: DadosCadastrais,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/dependentes",
    name: "Dependentes",
    component: Dependentes,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/avisos",
    name: "Avisos",
    component: Avisos,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/telefonia",
    name: "Telefona",
    component: Telefonia,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/compras-varejo",
    name: "Compras",
    component: Compras,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/pip",
    name: "Pip",
    component: Pip,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/espelho-ponto",
    name: "EspelhoPonto",
    component: EspelhoPonto,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/beneficios",
    name: "Benefícios",
    component: Beneficios,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/avaliacao",
    name: "Avaliacao",
    component: Avaliacao,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/fale-com-rh",
    name: "FaleComRh",
    component: FaleComRh,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/marcacao-ponto",
    name: "MarcacoesPonto",
    component: MarcacoesPonto,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/varejo",
    name: "ItensDoVarejo",
    component: ItensDoVarejo,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/cartilha",
    name: "Cartilha",
    component: Cartilha,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/programacao",
    name: "Programacao",
    component: Programacao,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/documentos",
    name: "Documentos",
    component: Documentos,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/inclusao-ponto",
    name: "InclusaoPonto",
    component: InclusaoPonto,    
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/oportunidade-interna",
    name: "Oportunidades",
    component: Oportunidades,    
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/reserva-restaurante",
    name: "Reservas",
    component: Reservas,    
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/vale-refeicao",
    name: "Vale",
    component: Vale,    
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/inclusao-ponto-teletex",
    name: "InclusaoPontoTeletex",
    component: InclusaoPontoTeletex,    
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
  {
    path: "/denuncia",
    name: "Denuncia",
    component: Denuncia,    
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },  
  {
    path: "*",
    name: "Erro404",
    component: Erro404,
    beforeEnter: (to, from, next) => {
      if (sessionStorage.getItem("logado") === "true") {
        next();
      }
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
